import * as yup from 'yup'
import { minPasswordLength } from 'src/components/joinBusiness/validation';



export const validationSchemaEmail = yup.object().shape({
    email: yup.string().required().email(),
})

export const validationSchemaCompanyInformation = yup.object().shape({
    organizationNumber: yup.string().required(),
    companyName: yup.string().required(),
    disallowNewContacts: yup.bool().default(false).isFalse(),
})

export const validationSchemaAdditionalUserRequest = yup.object().shape({
    organizationNumber: yup.string().required(),
    companyName: yup.string().required(),
    disallowNewContacts: yup.bool().default(false).isTrue(),
    email: yup.string().required().email(),
    name: yup.string().required().max(50)
})

export const validationSchemaAccount = yup.object().shape({
    firstName: yup.string().required().max(25),
    lastName: yup.string().required().max(25),
    isAuthenticated: yup.bool(),
    acceptAccountTerms: yup
        .bool().isTrue(),
    offersByEmail: yup.bool(),
})

export const validationSchemaPassword = yup.object().shape({
    password: yup.string().max(72).min(minPasswordLength).required(),
    confirmNewPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match') // Ensures it matches `password`
    .max(72)
    .min(minPasswordLength)
    .required('Confirm Password is required')
    
})
